import Vue from 'vue';
import Vuex from 'vuex';
import moment from 'moment';
import {
  ValidationProvider,
  ValidationObserver,
  extend,
} from 'vee-validate';
import { required, email, confirmed } from 'vee-validate/dist/rules';
import Orders from '../apps/orders/index.vue';
import store from '../store/store';

// Import / Add Vee-Validators
extend('email', email);

// extend('confirmed', confirmed);

extend('confirmed', {
  validate: (value, { other }) => value === other,
  message: 'The email does not match',
  params: [{ name: 'other', isTarget: true }],
});

extend('required', {
  ...required,
  message: 'The {_field_} field is required',
});

extend('phone', {
  validate: (value) => value.replace(/\D/g, '').length === 10,
  message: 'Phone number must be ten digits',
});

// Register validation components
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

Vue.use(Vuex);
Vue.prototype.moment = moment;

document.addEventListener('DOMContentLoaded', () => {
  const {
    stripePubKey,
    postalCode,
    railsEnv,
    adProductId,
    adDivisionId
  } = document.getElementById('orders').dataset;

  if (stripePubKey.length > 0) {
    const stripe = window.Stripe(stripePubKey);
    store.commit('setProperties', { stripe });
  }
  store.dispatch('prepEmptyOrder', postalCode);
  store.commit('setProperties', { railsEnv });
  store.commit('setProperties', { adProductId });
  store.commit('setProperties', { adDivisionId: parseInt(adDivisionId, 10) });

  const app = new Vue({
    el: '#orders',
    store,
    render(createElement) {
      return createElement(Orders);
    },
  }).$mount();
});
